import React, { useEffect, useState } from "react";
import { CryptoState } from "../CryptoContext";
import axios from "axios";
import { HistoricalChart } from "../config/api";
import {
  CircularProgress,
  ThemeProvider,
  createTheme,
  makeStyles,
} from "@material-ui/core";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { Chart } from "react-chartjs-2";
import { chartDays } from "../config/data";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "75%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 25,
    padding: 40,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginTop: 0,
      padding: 20,
      paddingTop: 0,
    },
  },
  wrapping:{
      display: "flex",
      gap:20,
      marginTop: 20,
      justifyContent: "space-around",
      width: "100%",
      [theme.breakpoints.down("md")]: {
        flexWrap:"wrap",
        gap:10
      },
  }
}));

function Coininfo({ coin }) {
  const [historicalData, setHistoricalData] = useState();
  const [days, setDays] = useState("24h");

  const classes = useStyles();

  const { currency, symbol } = CryptoState();

  const fetchHistoricalData = async () => {
    const { data } = await axios.get(HistoricalChart(coin.id, days, currency));
    setHistoricalData(data.prices);
  };

  useEffect(() => {
    fetchHistoricalData();
  }, [days, currency]);

  const darkTheme = createTheme({
    palette: {
      primary: {
        main: "#fff",
      },
      type: "dark",
    },
  });

  // console.log(historicalData);

  return (
    <ThemeProvider theme={darkTheme}>
      <div className={classes.container}>
        {!historicalData ? (
          <CircularProgress
            style={{ color: "#e64072" }}
            size={250}
            thickness={1}
          />
        ) : (
          <>
            <Line
              data={{
                labels: historicalData.map((coin) => {
                  let date = new Date(coin[0]);
                  let time =
                    date.getHours() > 12
                      ? `${date.getHours() - 12}:${date.getMinutes()} PM`
                      : `${date.getHours()}:${date.getMinutes()} AM`;
                  return days === "24h" ? time : date.toLocaleDateString();
                }),
                datasets: [
                  {
                    data: historicalData.map((coin) => coin[1]),
                    label: `Price (Past ${days} Days) in ${currency}`,
                    borderColor: "#e64072",
                  },
                ],
              }}
              options={{
                elements: {
                  point: {
                    radius: 1,
                  },
                },
              }}
            />
            <div className={classes.wrapping}>
              {chartDays.map((day) => (
                <button
                  key={day.value}
                  onClick={() => {setDays(day.value)}}
                  style={{
                    border: "1px solid #e64072",
                  borderRadius: 5,
                  padding: 10,
                  fontFamily: "Montserrat",
                  cursor: "pointer",
                  backgroundColor: day.value === days ? "#e64072" : "#000080",
                  color: day.value === days ? "#000080" : "white",
                  fontWeight: day.value === days ? 700 : 500,
                  "&:hover": {
                    backgroundColor: "#e64072",
                    color: "#000080",
                  },
                  width: "22%",
                }}
                  // selected={day.value === days}
                >
                  {day.label}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </ThemeProvider>
  );
}

export default Coininfo;
